import React from "react";
import { Link } from "react-router-dom";
import "../css/PackagesDetail.css";
import PrivatePartyPackages from "../components/PrivatePartyPackages";
import Icon from "../components/Icon";
import {
  weekdayPartyPackages,
  partyAddOns,
  locationRental,
  formatPackagePrice,
  getPackageDetails,
} from "../data/packages";
import { bookingPolicies, PRICE_DISCLOSURE } from "../data/bookingPolicies";

function OtherPackageCard({ pkg, eventType }) {
  return (
    <article className="other-package-card">
      <h3>{pkg.title}</h3>
      <p className="other-package-price">{formatPackagePrice(pkg.price)}</p>
      <p className="package-tax">{PRICE_DISCLOSURE}</p>
      <ul className="package-details">
        {getPackageDetails(pkg).map((detail, index) => (
          <li key={index}>
            <span>{detail.label}</span>
            {detail.value && <strong>{detail.value}</strong>}
          </li>
        ))}
      </ul>
      <Link className="button button-secondary" to={"/book?event=" + eventType}>
        Ask about {eventType === "rental" ? "a rental" : "this party"} <Icon />
      </Link>
    </article>
  );
}

export default function PackagesDetail() {
  return (
    <div className="packages-detail-section">
      <div className="site-container section-space">
        <header className="page-intro">
          <p className="eyebrow">THEIR BIG DAY, BEAUTIFULLY PLANNED</p>
          <h1>
            A celebration fit for
            <br />
            <span>your little royal.</span>
          </h1>
          <p>
            Find room for every giggle, every guest, and every birthday wish.
            Explore our private parties, weekday celebrations, and the little
            extras.
          </p>
          <nav className="party-jump-links" aria-label="Party page sections">
            <a href="#private-parties">Private packages</a>
            <a href="#weekday-parties">Weekday parties</a>
            <a href="#party-extras">Add-ons & rentals</a>
            <a href="#booking-policies">Booking policies</a>
          </nav>
        </header>
        <section id="private-parties" aria-labelledby="private-party-title">
          <PrivatePartyPackages headingId="private-party-title" />
        </section>
        <section
          id="weekday-parties"
          className="party-subsection"
          aria-labelledby="weekday-title"
        >
          <div className="section-heading">
            <p className="eyebrow">SMALLER PARTIES, PLENTY OF PLAY</p>
            <h2 id="weekday-title">Non-private weekday parties</h2>
            <p>
              Monday–Thursday only. Celebrate during open play.{" "}
              {PRICE_DISCLOSURE}.
            </p>
          </div>
          <div className="other-packages-grid">
            {weekdayPartyPackages.map((pkg) => (
              <OtherPackageCard key={pkg.id} pkg={pkg} eventType="weekday" />
            ))}
          </div>
        </section>
        <section
          id="party-extras"
          className="party-subsection"
          aria-labelledby="extras-title"
        >
          <div className="section-heading">
            <p className="eyebrow">MAKE IT YOURS</p>
            <h2 id="extras-title">A little extra magic.</h2>
            <p>
              Optional add-ons and standalone rentals are priced separately.{" "}
              {PRICE_DISCLOSURE}.
            </p>
          </div>
          <div className="extras-grid">
            <article className="other-package-card">
              <h3>{partyAddOns.title}</h3>
              <p className="other-package-price">{partyAddOns.price}</p>
              <p className="package-tax">{PRICE_DISCLOSURE}</p>
              <ul className="package-details">
                {partyAddOns.details.map((detail, index) => (
                  <li key={index}>
                    <span>{detail.label}</span>
                    <strong>{detail.value}</strong>
                  </li>
                ))}
              </ul>
              <Link className="text-link" to="/book">
                Tell us what you have in mind <Icon />
              </Link>
            </article>
            <OtherPackageCard pkg={locationRental} eventType="rental" />
          </div>
        </section>
        <section
          id="booking-policies"
          className="party-subsection"
          aria-labelledby="policies-title"
        >
          <div className="section-heading">
            <p className="eyebrow">A FEW DETAILS BEFORE THE BIG DAY</p>
            <h2 id="policies-title">Booking policies</h2>
            <p>
              Please review deposits, payments, event guidelines, and applicable
              fees before booking.
            </p>
          </div>
          <div className="booking-policy-card">
            <ul>
              {bookingPolicies.map((policy, index) => (
                <li key={index}>
                  <Icon name="check" />
                  <span>{policy}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="party-ready-callout">
            <div>
              <h3>Let’s make a birthday happen.</h3>
              <p>
                Send your preferred date and guest count. Our team will confirm
                availability and next steps.
              </p>
            </div>
            <Link className="button button-primary" to="/book">
              Plan your party <Icon />
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
